var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFermer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32.8 33",
    style: {
      enableBackground: "new 0 0 32.8 33"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M16.5,0.4C7.6,0.4,0.3,7.7,0.3,16.6C0.3,20.9,2,25,5.1,28c3.1,3.1,7.1,4.7,11.4,4.7c8.9,0,16.2-7.3,16.2-16.2 C32.6,7.7,25.4,0.4,16.5,0.4z M30.1,16.6c0,7.5-6.1,13.6-13.6,13.6c-3.6,0-7.1-1.4-9.6-4c-2.6-2.6-4-6-4-9.6C2.9,9.1,9,3,16.5,3 C24,3,30.1,9.1,30.1,16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M24.2,8.8c-0.5-0.5-1.2-0.5-1.7,0l-6,6l-6-6c-0.5-0.5-1.2-0.5-1.7,0C8.5,9.1,8.4,9.4,8.4,9.7 c0,0.3,0.1,0.6,0.4,0.9l6,6l-6,6c-0.2,0.2-0.4,0.5-0.4,0.9c0,0.3,0.1,0.6,0.4,0.9c0.2,0.2,0.5,0.4,0.9,0.4s0.6-0.1,0.9-0.4l6-6l6,6 c0.2,0.2,0.5,0.4,0.9,0.4c0.3,0,0.6-0.1,0.9-0.4c0.5-0.5,0.5-1.2,0-1.7l-6-6l6-6C24.7,10.1,24.7,9.3,24.2,8.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFermer);
export default __webpack_public_path__ + "static/media/Fermer.9e6b2305.svg";
export { ForwardRef as ReactComponent };